import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { ISettlementProposalFilterData } from 'gen/ApiClient';

export const FilterDataContext = React.createContext<ICacheContext<ISettlementProposalFilterData>>(undefined as any);
